import React, { FunctionComponent } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Flex } from 'antd';

interface DoughnutComponentProps {
	percentage?: number | string;
	data: number[];
	colors?: string[];
	header?: React.ReactNode;
	footer?: React.ReactNode;
	size?: number;
}

const DoughnutComponent: FunctionComponent<DoughnutComponentProps> = ({ percentage, data, colors, header, footer, size = 120 }) => {
	return (
		<Flex vertical gap={10} align="center" justify="center">
			{header}

			<div style={{ width: size, height: size, position: 'relative' }}>
				<Doughnut
					width={size}
					height={size}
					options={{
						cutout: '75%',
					}}
					data={{
						datasets: [
							{
								data: data,
								backgroundColor: colors,
							},
						],
					}}
				/>

				<h6 className="centered">{percentage}%</h6>
			</div>

			{footer}
		</Flex>
	);
};

export default DoughnutComponent;
